@if (data$ | async; as data) {
    <div
        class="aimo-background"
        [class]="getBgClass(data)"></div>
    <div class="container">
        <div class="aimo-landing-page-text">
            <h1>{{ data.title }}</h1>
            <p [innerHTML]="data.text">{{ data.text }}</p>
        </div>
    </div>
}
